/* eslint-disable */
/*
  oJo, no hacer multininea.

  oJo, poner raiz la categoría: ej.-
     Blockly.Msg["SENSOR_(nombre del mensaje)"]

  oJo, no sacar literales aunque se dupliquen (son pocas): ej.-
     Blockly.Msg["COPY_TO_BACKPACK"] = "Copiar a la motchila"; <- OK
     Blockly.Msg["COPY"] = "Copiar";                           <- NO OK
     Blockly.Msg["BACKPACK"] = "motchila";                     <- NO OK

  oJo, hacer las modificaciones en los 4 diomas a la vez!!!,
    la idea es que coincidan línea a línea,
    no dejar una traducción hecha en un idioma y no en el resto.
*/

import Blockly from "blockly";

export function ACA() {
  Blockly = {};
  Blockly.Msg = {};

  // Blocks - COMMON
  Blockly.Msg["ADD_NEW_LINE"] = "Salt de línia";
  Blockly.Msg["AS"] = "com";
  Blockly.Msg["BAUDRATE"] = "bauds";
  Blockly.Msg["BOOLEAN_FALSE"] = "fals";
  Blockly.Msg["BOOLEAN_OFF"] = "OFF";
  Blockly.Msg["BOOLEAN_ON"] = "ON";
  Blockly.Msg["BOOLEAN_TRUE"] = "veritable";
  Blockly.Msg["COL"] = "Columna";
  Blockly.Msg["COLOUR"] = "Color";
  Blockly.Msg["DEFAULT_VAR_NAME"] = "varNum";
  Blockly.Msg["DO"] = "fes";
  Blockly.Msg["FIX"] = "Fixa";
  Blockly.Msg["I2C_ADDRESS"] = "Adreça";
  Blockly.Msg["I2C_BEGIN"] = "Inicia (I2C)";
  Blockly.Msg["ID"] = "#";
  Blockly.Msg["PIN"] = "PIN";
  Blockly.Msg["ROW"] = "Fila";
  Blockly.Msg["STATUS"] = "Estat";
  Blockly.Msg["TIMEOUT"] = "temps màxim";
  Blockly.Msg["UNTIL_NEW_LINE"] = "Fins a salt de línia";
  Blockly.Msg["VALUE"] = "Valor";
  Blockly.Msg["UPLOAD"] = "Upload"; // OjO, sin traducir

  // Blocks - LOGIC
  Blockly.Msg["LOGIC_BOOLEAN_FALSE"] = Blockly.Msg["BOOLEAN_FALSE"];
  Blockly.Msg["LOGIC_BOOLEAN_OFF"] = Blockly.Msg["BOOLEAN_OFF"];
  Blockly.Msg["LOGIC_BOOLEAN_ON"] = Blockly.Msg["BOOLEAN_ON"];
  Blockly.Msg["LOGIC_BOOLEAN_TOOLTIP"] = "Torna veritable o fals.";
  Blockly.Msg["LOGIC_BOOLEAN_TRUE"] = Blockly.Msg["BOOLEAN_TRUE"];
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_EQ"] = "Torna veritable si ambdues entrades són iguals.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GT"] = "Torna veritable si la primera entrada és més gran que la segona entrada.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GTE"] = "Torna veritable si la primera entrada és més gran o igual a la segona entrada.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LT"] = "Torna veritable si la primera entrada és més petita que la segona entrada.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LTE"] = "Torna veritable si la primera entrada és més petita o igual a la segona entrada.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_NEQ"] = "Torna veritable si ambdues entrades són diferents.";
  Blockly.Msg["LOGIC_NEGATE_TITLE"] = "no %1";
  Blockly.Msg["LOGIC_NEGATE_TOOLTIP"] = "Torna veritable si l'entrada és falsa. Torna fals si l'entrada és veritable.";
  Blockly.Msg["LOGIC_OPERATION_AND"] = "i";
  Blockly.Msg["LOGIC_OPERATION_OR"] = "o";
  Blockly.Msg["LOGIC_OPERATION_TOOLTIP_AND"] = "Torna veritable si ambdues entrades són veritables.";
  Blockly.Msg["LOGIC_OPERATION_TOOLTIP_OR"] = "Torna veritable si, com a mínim, una de les entrades és veritable.";
  Blockly.Msg["LOGIC_IF_MSG_ELSE"] = "Si no";
  Blockly.Msg["LOGIC_IF_MSG_ELSEIF"] = "Si no, si";
  Blockly.Msg["LOGIC_IF_MSG_IF"] = "Si";
  Blockly.Msg["LOGIC_IF_MSG_THEN"] = Blockly.Msg["DO"];
  Blockly.Msg["LOGIC_IF_TOOLTIP"] = "Si la comparació és certa, executa els blocs associats.";

  // Blocks - CONTROLS
  Blockly.Msg["CONTROLS_FOR_TITLE"] = "Compta amb %1 des de %2 fins a %3 en intervals de %4";
  Blockly.Msg["CONTROLS_FOR_TOOLTIP"] = "Fa que la variable \"%1\" prengui valors des del nombre d'inici fins al nombre final, tenint en compte l'interval especificat, i fa els blocs especificats.";
  Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"] = Blockly.Msg["DO"];
  Blockly.Msg["CONTROLS_REPEAT_TITLE"] = "Repeteix %1 vegades";
  Blockly.Msg["CONTROLS_REPEAT_TOOLTIP"] = "Fa algunes declaracions diverses vegades.";
  Blockly.Msg["CONTROLS_WHILEUNTIL_INPUT_DO"] = Blockly.Msg["DO"];
  Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_UNTIL"] = "Repeteix fins";
  Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_WHILE"] = "Repeteix  mentre";
  Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL"] = "Mentre un valor sigui fals, llavors fa algunes declaracions.";
  Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_WHILE"] = "Mentre un valor sigui veritable, llavors fa algunes declaracions.";
  Blockly.Msg["CONTROLS_ARDUINO_LOOP"] = "Bucle";
  Blockly.Msg["CONTROLS_ARDUINO_SETUP"] = "Inicialitza";
  Blockly.Msg["CONTROLS_GROUP"] = "Agrupa";

  // Blocks - MATH
  Blockly.Msg["MATH_ADDITION_SYMBOL"] = "+";
  Blockly.Msg["MATH_ANGLE"] = "angle";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_ADD"] = "Torna la suma d'ambdós nombres.";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_DIVIDE"] = "Torna el quocient d'ambdós nombres.";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MINUS"] = "Torna la diferència d'ambdós nombres.";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MULTIPLY"] = "Torna el producte d'ambdós nombres.";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_POWER"] = "Torna el primer nombre elevat a la potència del segon.";
  Blockly.Msg["MATH_CHANGE_TITLE"] = "Canvia %1 per %2";
  Blockly.Msg["MATH_CHANGE_TITLE_ITEM"] = Blockly.Msg["DEFAULT_VAR_NAME"];
  Blockly.Msg["MATH_CHANGE_TOOLTIP"] = "Afegeix un nombre a la variable «%1».";
  Blockly.Msg["MATH_CONSTRAIN_TITLE"] = "limita %1 entre %2 i %3";
  Blockly.Msg["MATH_CONSTRAIN_TOOLTIP"] = "Limita un nombre entre els límits especificats, ambdós inclosos.";
  Blockly.Msg["MATH_DIVISION_SYMBOL"] = "÷";
  Blockly.Msg["MATH_MAP_TITLE"] = "mapa %1 de %2 - %3 a %4 - %5";
  Blockly.Msg["MATH_MAP_TOOLTIP"] = "Mapa un nombre d'un rang a un altre.";
  Blockly.Msg["MATH_MODULO_TITLE"] = "residu de %1 ÷ %2";
  Blockly.Msg["MATH_MODULO_TOOLTIP"] = "Torna el residu en dividir els dos nombres.";
  Blockly.Msg["MATH_MULTIPLICATION_SYMBOL"] = "×";
  Blockly.Msg["MATH_NUMBER_TOOLTIP"] = "Un nombre.";
  Blockly.Msg["MATH_POWER_SYMBOL"] = "^";
  Blockly.Msg["MATH_RANDOM_INT_TITLE"] = "enter aleatori de %1 a %2";
  Blockly.Msg["MATH_RANDOM_INT_TOOLTIP"] = "Torna un enter aleatori entre els dos límits especificats, ambdós inclosos.";
  Blockly.Msg["MATH_SINGLE_OP_ABSOLUTE"] = "absolut";
  Blockly.Msg["MATH_SINGLE_OP_LN"] = "log(e)";
  Blockly.Msg["MATH_SINGLE_OP_LOG10"] = "log(10)";
  Blockly.Msg["MATH_SINGLE_OP_NEG"] = "-";
  Blockly.Msg["MATH_SINGLE_OP_ROOT"] = "arrel quadrada";
  Blockly.Msg["MATH_SINGLE_OP_ROUND"] = "arrodoneix";
  Blockly.Msg["MATH_SINGLE_OP_ROUNDDOWN"] = "aproxima per defecte";
  Blockly.Msg["MATH_SINGLE_OP_ROUNDUP"] = "aproxima per excés";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ABS"] = "Torna el valor absolut d'un nombre.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_EXP"] = "Torna e a la potència d'un nombre.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_LN"] = "Torna el logaritme natural d'un nombre.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_LOG10"] = "Torna el logaritme amb base 10 d'un nombre.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_NEG"] = "Torna el valor negatiu d'un nombre.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_POW10"] = "Torna 10 a la potència d'un nombre.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ROOT"] = "Torna l'arrel quadrada d'un nombre.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ROUND"] = "Arrodoneix un nombre cap amunt o cap avall.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ROUNDUP"] = "Aproxima un nombre cap amunt.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ROUNDDOWN"] = "Aproxima un nombre cap avall.";
  Blockly.Msg["MATH_SINGLE_TRIG_ACOS"] = "acos";
  Blockly.Msg["MATH_SINGLE_TRIG_ASIN"] = "asin";
  Blockly.Msg["MATH_SINGLE_TRIG_ATAN"] = "atan";
  Blockly.Msg["MATH_SINGLE_TRIG_COS"] = "cos";
  Blockly.Msg["MATH_SINGLE_TRIG_SIN"] = "sin";
  Blockly.Msg["MATH_SINGLE_TRIG_TAN"] = "tan";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_ACOS"] = "Torna l'arccosinus d'un nombre.";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_ASIN"] = "Torna l'arcsinus d'un nombre.";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_ATAN"] = "Torna l'arctangent d'un nombre.";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_COS"] = "Torna el cosinus d'un grau (no radian).";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_SIN"] = "Torna el sinus d'un grau (no radian).";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_TAN"] = "Torna la tangent d'un grau (no radian).";
  Blockly.Msg["MATH_SUBTRACTION_SYMBOL"] = "-";
  Blockly.Msg["MATH_TO_INT"] = "nombre enter";
  Blockly.Msg["MATH_TO_UINT"] = "nombre enter sense signe";
  Blockly.Msg["MATH_TRIG_ATAN2"] = "atan2";
  Blockly.Msg["MATH_TRIG_TOOLTIP_ATAN2"] = "Torna l'arctangent de y/x.";

  // Blocks - TEXT
  Blockly.Msg["TEXT_AS"] = Blockly.Msg["AS"];
  Blockly.Msg["TEXT_ASCII"] = "Valor ASCII";
  Blockly.Msg["TEXT_CONTAINS"] = "conté en el text";
  Blockly.Msg["TEXT_CONTAINS_1"] = "cadena";
  Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TITLE_ITEM"] = Blockly.Msg["DEFAULT_VAR_NAME"];
  Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TOOLTIP"] = "Afegeix un element al text.";
  Blockly.Msg["TEXT_CREATE_JOIN_TITLE_JOIN"] = "uneix";
  Blockly.Msg["TEXT_CREATE_JOIN_TOOLTIP"] = "Afegeix, elimina o reordena les seccions per reconfigurar aquest bloc de text.";
  Blockly.Msg["TEXT_DECIMAL"] = "decimals";
  Blockly.Msg["TEXT_ENDSWITH"] = "acaba amb";
  Blockly.Msg["TEXT_EQUALS"] = "igual a";
  Blockly.Msg["TEXT_EQUALS_IGNORE"] = "igual a (ignora majúscules)";
  Blockly.Msg["TEXT_FORMAT"] = "formata nombre";
  Blockly.Msg["TEXT_INDEXOF"] = "busca en el text";
  Blockly.Msg["TEXT_INDEXOF_1"] = "cadena";
  Blockly.Msg["TEXT_INDEXOF_FIRST"] = "primera";
  Blockly.Msg["TEXT_INDEXOF_LAST"] = "última";
  Blockly.Msg["TEXT_JOIN_TITLE_CREATEWITH"] = "crea text amb";
  Blockly.Msg["TEXT_JOIN_TOOLTIP"] = "Crea un fragment de text en unir qualsevol nombre d'elements.";
  Blockly.Msg["TEXT_LENGTH_TITLE"] = "longitud de %1";
  Blockly.Msg["TEXT_LENGTH_TOOLTIP"] = "Torna el nombre de lletres (incloent espais) del text proporcionat.";
  Blockly.Msg["TEXT_NOT_EQUALS"] = "diferent de";
  Blockly.Msg["TEXT_REPLACE"] = "Reemplaça el text";
  Blockly.Msg["TEXT_REPLACE_1"] = "segment";
  Blockly.Msg["TEXT_REPLACE_2"] = "reemplaçament";
  Blockly.Msg["TEXT_STARTSWITH"] = "comença amb";
  Blockly.Msg["TEXT_SUBSTRING"] = "parteix text";
  Blockly.Msg["TEXT_SUBSTRING_1"] = "inici";
  Blockly.Msg["TEXT_SUBSTRING_2"] = "fi";
  Blockly.Msg["TEXT_TEXT_TOOLTIP"] = "Una lletra, paraula o línia de text.";
  Blockly.Msg["TEXT_TONUMBER"] = "text a nombre";
  Blockly.Msg["TEXT_WITH"] = "amb";

  // Blocks - VARIABLES
  Blockly.Msg["VARIABLES_DEFAULT_NAME"] = Blockly.Msg["DEFAULT_VAR_NAME"];
  Blockly.Msg["VARIABLES_DEFAULT_NAME_BOOL"] = "varBool";
  Blockly.Msg["VARIABLES_DEFAULT_NAME_TEXT"] = "varText";
  Blockly.Msg["VARIABLES_GET_CREATE_SET"] = "Crea 'estableix %1'";
  Blockly.Msg["VARIABLES_GET_TOOLTIP"] = "Torna el valor d'aquesta variable.";
  Blockly.Msg["VARIABLES_SET"] = "Estableix";
  Blockly.Msg["VARIABLES_SET_CREATE_GET"] = "Crea 'obtingues %1'";
  Blockly.Msg["VARIABLES_SET_TOOLTIP"] = "Estableix aquesta variable perquè sigui igual a l'entrada.";

  // Blocks - LISTS
  Blockly.Msg["LISTS_CREATE_EMPTY_TITLE"] = "llista buida";
  Blockly.Msg["LISTS_CREATE_TITLE"] = "Crea llista %1 %2 %3";
  Blockly.Msg["LISTS_CREATE_WITH_INPUT_NUMBER_WITH"] = "número ";
  Blockly.Msg["LISTS_CREATE_WITH_INPUT_TEXT_WITH"] = "text ";
  Blockly.Msg["LISTS_CREATE_WITH_TOOLTIP"] = "Crea una llista amb els elements indicats.";
  Blockly.Msg["LISTS_CREATE_WITH_INPUT_WITH"] = "Crea llista numèrica";
  Blockly.Msg["LISTS_CREATE_WITH_INPUT_WITH_TEXT"] = "Crea llista de textos";
  Blockly.Msg["LISTS_CREATE_WITH_ITEM_TITLE"] = Blockly.Msg["DEFAULT_VAR_NAME"];
  Blockly.Msg["LISTS_GET_INDEX_GET"] = "obtingues element";
  Blockly.Msg["LISTS_GET_INDEX_TOOLTIP"] = "Torna l'element de l'índex indicat.";
  Blockly.Msg["LISTS_SET_INDEX_TOOLTIP"] = "Estableix un element de l'índex indicat.";
  Blockly.Msg["LISTS_LENGTH_TITLE"] = "longitud de";
  Blockly.Msg["LISTS_LENGTH_TOOLTIP"] = "Torna la longitud d'una llista.";
  Blockly.Msg["LISTS_LISTNAME"] = "llistaNum";
  Blockly.Msg["LISTS_LISTNAME_TEXT"] = "llistaText";
  Blockly.Msg["LISTS_SET_INDEX_SET"] = "estableix element";

  // Blocks - PROCEDURES
  Blockly.Msg["PROCEDURES_ALLOW_STATEMENTS"] = "permet declaracions";
  Blockly.Msg["PROCEDURES_BEFORE_PARAMS"] = "amb:";
  Blockly.Msg["PROCEDURES_CALLNORETURN_TOOLTIP"] = "Executa la funció definida per l'usuari '%1'.";
  Blockly.Msg["PROCEDURES_CALLRETURN_TOOLTIP"] = "Executa la funció definida per l'usuari '%1' i utilitza la seva sortida.";
  Blockly.Msg["PROCEDURES_CALL_BEFORE_PARAMS"] = "amb:";
  Blockly.Msg["PROCEDURES_CREATE_DO"] = "Crea '%1'";
  Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"] = "Descriu aquesta funció…";
  Blockly.Msg["PROCEDURES_DEFNORETURN_DO"] = "";
  Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"] = "fer alguna cosa";
  Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"] = "Per a";
  Blockly.Msg["PROCEDURES_DEFNORETURN_TOOLTIP"] = "Crea una funció sense sortida.";
  Blockly.Msg["PROCEDURES_DEFRETURN_RETURN"] = "torna";
  Blockly.Msg["PROCEDURES_DEFRETURN_TOOLTIP"] = "Crea una funció amb una sortida.";
  Blockly.Msg["PROCEDURES_DEF_DUPLICATE_WARNING"] = "Advertència: Aquesta funció té paràmetres duplicats.";
  Blockly.Msg["PROCEDURES_HIGHLIGHT_DEF"] = "Destaca definició de la funció";
  Blockly.Msg["PROCEDURES_IFRETURN_TOOLTIP"] = "Si un valor és cert, torna el valor.";
  Blockly.Msg["PROCEDURES_IFRETURN_WARNING"] = "Avís: Aquest bloc només pot utilitzar-se dins de la definició d'una funció.";
  Blockly.Msg["PROCEDURES_MUTATORARG_TITLE"] = "nom de l'entrada:";
  Blockly.Msg["PROCEDURES_MUTATORARG_TOOLTIP"] = "Afegeix una entrada a la funció.";
  Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TITLE"] = "entrades";
  Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TOOLTIP"] = "Afegeix, elimina o reordena entrades per a aquesta funció.";
  Blockly.Msg["PROCEDURES_VARIABLE"] = "argument:";
  Blockly.Msg["PROCEDURES_DEFRETURN_COMMENT"] = Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"];
  Blockly.Msg["PROCEDURES_DEFRETURN_DO"] = Blockly.Msg["PROCEDURES_DEFNORETURN_DO"];
  Blockly.Msg["PROCEDURES_DEFRETURN_PROCEDURE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"];
  Blockly.Msg["PROCEDURES_DEFRETURN_TITLE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"];

  // Blocks - IO
  Blockly.Msg["IO_ANALOG_READ"] = "Llegeix PIN analògic";
  Blockly.Msg["IO_ANALOG_READ_DIF"] = "Llegeix analògica diferencial";
  Blockly.Msg["IO_ANALOG_WRITE"] = "Escriu PWM PIN analògic";
  Blockly.Msg["IO_CAPACITIVE_READ"] = "Llegeix entrada capacitiva";
  Blockly.Msg["IO_DIGITAL_READ"] = "Llegeix PIN digital";
  Blockly.Msg["IO_DIGITAL_WRITE"] = "Escriu PIN digital";
  Blockly.Msg["IO_INTERRUPT"] = "Interrupció";
  Blockly.Msg["IO_INT_RISING"] = "flanc ascendent";
  Blockly.Msg["IO_INT_FALLING"] = "flanc descendent";
  Blockly.Msg["IO_INT_CHANGE"] = "canvi d'estat";
  Blockly.Msg["IO_INT_LOW"] = "estat en baix";
  Blockly.Msg["IO_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["IO_PINMODE"] = "Configura pin";
  Blockly.Msg["IO_PINMODE_AS"] = Blockly.Msg["AS"];
  Blockly.Msg["IO_PULSEIN"] = "Llegeix pols";
  Blockly.Msg["IO_PULSEIN_TIMEOUT"] = "Temps d'espera";
  Blockly.Msg["IO_VALUE"] = Blockly.Msg["VALUE"];

  // Blocks - TIME
  Blockly.Msg["TIME_MICROS"] = "microsegons";
  Blockly.Msg["TIME_MILLIS"] = "mil·lisegons";
  Blockly.Msg["TIME_SECONDS"] = "segons";
  Blockly.Msg["TIME_RUNEVERYMS"] = "Executa cada";
  Blockly.Msg["TIME_SNOOZE"] = "Dormir";
  Blockly.Msg["TIME_TIMER"] = "Cronòmetre";
  Blockly.Msg["TIME_TIMER_RESET"] = "Reinicia el cronòmetre";
  Blockly.Msg["TIME_TIME_ELAPSED_SECONDS"] = "Temps transcorregut en segons";
  Blockly.Msg["TIME_TIME_ELAPSED_MILLI"] = "Temps transcorregut en mil·lisegons";
  Blockly.Msg["TIME_TIME_ELAPSED_MICRO"] = "Temps transcorregut en microsegons";
  Blockly.Msg["TIME_WAIT"] = "Espera";
  Blockly.Msg["TIME_WAIT_FOREVER"] = "Espera per sempre FI";
  Blockly.Msg["TIME_WAIT_UNTIL"] = "Espera fins que";
  Blockly.Msg["TIME_WAIT_WHILE"] = "Espera mentre que";

  // Blocks - SERIAL
  Blockly.Msg["SERIAL_ADD_NEW_LINE"] = Blockly.Msg["ADD_NEW_LINE"];
  Blockly.Msg["SERIAL_AVAILABLE"] = "Dades rebudes?";
  Blockly.Msg["SERIAL_BAUDRATE"] = Blockly.Msg["BAUDRATE"];
  Blockly.Msg["SERIAL_FLUSH"] = "Buida dades";
  Blockly.Msg["SERIAL_FIX"] = Blockly.Msg["FIX"];
  Blockly.Msg["SERIAL_INIT"] = "Inicia";
  Blockly.Msg["SERIAL_INT"] = "Esdeveniment al port";
  Blockly.Msg["SERIAL_PLOT_CREATE_TITLE"] = "Port Sèrie %1 Gràfica: %2 %3";
  Blockly.Msg["SERIAL_PLOT_CREATE_WITH_INPUT_NAME"] = "nom ";
  Blockly.Msg["SERIAL_PLOT_CREATE_WITH_INPUT_NUMBER"] = "valor ";
  Blockly.Msg["SERIAL_PLOT_CREATE_WITH_TOOLTIP"] = "Gràfica per a qualsevol nombre de senyals.";
  Blockly.Msg["SERIAL_PLOT_CREATE_EMPTY_TITLE"] = "gràfica buida";
  Blockly.Msg["SERIAL_PRINT"] = "Envia";
  Blockly.Msg["SERIAL_PRINTLN"] = "Envia línia";
  Blockly.Msg["SERIAL_READ"] = "Rep";
  Blockly.Msg["SERIAL_READBYTE"] = "Rep byte";
  Blockly.Msg["SERIAL_READFLOAT"] = "Rep com a nombre";
  Blockly.Msg["SERIAL_READINT"] = "Rep com a nombre enter";
  Blockly.Msg["SERIAL_READSTRING"] = "Rep text";
  Blockly.Msg["SERIAL_READSTRINGLINE"] = "Rep línia de text";
  Blockly.Msg["SERIAL"] = "Port Sèrie";
  Blockly.Msg["SERIAL_TIMEOUT"] = Blockly.Msg["TIMEOUT"];
  Blockly.Msg["SERIAL_UNTIL_NEW_LINE"] = Blockly.Msg["UNTIL_NEW_LINE"];
  Blockly.Msg["SERIAL_WRITEBYTE"] = "Envia byte";

  // Blocks - SENSOR
  Blockly.Msg["SENSOR_ACCEL_ADXL345"] = "Acceleròmetre (ADXL345)";
  Blockly.Msg["SENSOR_ACCEL_OFFSET"] = "Compensa";
  Blockly.Msg["SENSOR_BUTTON"] = "Polsador";
  Blockly.Msg["SENSOR_BUTTON_DEBOUNCED"] = "Polsador filtrat";
  Blockly.Msg["SENSOR_BUTTON_DEBOUNCED_PRESSED"] = "s'ha pitjat";
  Blockly.Msg["SENSOR_BUTTON_DEBOUNCED_RELEASED"] = "s'ha deixat anar";
  Blockly.Msg["SENSOR_BUTTON_INVERT"] = "Lògica invertida";
  Blockly.Msg["SENSOR_DHT11"] = "Sensor ambiental (DHT-11)";
  Blockly.Msg["SENSOR_DHT22"] = "Sensor ambiental (DHT-22)";
  Blockly.Msg["SENSOR_HUMIDITY"] = "Humitat %";
  Blockly.Msg["SENSOR_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["SENSOR_POT"] = "Potenciòmetre";
  Blockly.Msg["SENSOR_SOUND"] = "Micròfon";
  Blockly.Msg["SENSOR_TEMPERATURE"] = "Temperatura ºC";
  Blockly.Msg["SENSOR_TEMT6000"] = "Sensor de llum (TEMT6000)";
  Blockly.Msg["SENSOR_TILT"] = "Sensor d'inclinació (TILT)";
  Blockly.Msg["SENSOR_TMP36"] = "Sensor de temperatura (TMP36)";
  Blockly.Msg["SENSOR_ULTRASONIC"] = "Sensor de distància (HCSR-04)";
  Blockly.Msg["SENSOR_ULTRASONIC_MAXDISTANCE"] = "Max (cm)";
  Blockly.Msg["SENSOR_ULTRASONIC_UNITS"] = "Unitats";

  // Blocks - ACTUATOR
  Blockly.Msg["ACTUATOR_COLOUR"] = Blockly.Msg["COLOUR"];
  Blockly.Msg["ACTUATOR_COMMON_ANODE"] = "Ànode comú";
  Blockly.Msg["ACTUATOR_COMMON_CATHODE"] = "Càtode comú";
  Blockly.Msg["ACTUATOR_BOOLEAN_OFF"] = Blockly.Msg["BOOLEAN_OFF"];
  Blockly.Msg["ACTUATOR_BOOLEAN_ON"] = Blockly.Msg["BOOLEAN_ON"];
  Blockly.Msg["ACTUATOR_BUZZER"] = "Brunzidor";
  Blockly.Msg["ACTUATOR_BUZZER_DURATION"] = "Durada";
  Blockly.Msg["ACTUATOR_BUZZER_FREQ"] = "Freqüència";
  Blockly.Msg["ACTUATOR_BUZZER_TONE"] = "To";
  Blockly.Msg["ACTUATOR_NOTE_A"] = "LA";
  Blockly.Msg["ACTUATOR_NOTE_AS"] = "LA#";
  Blockly.Msg["ACTUATOR_NOTE_B"] = "SI";
  Blockly.Msg["ACTUATOR_NOTE_C"] = "DO";
  Blockly.Msg["ACTUATOR_NOTE_CS"] = "DO#";
  Blockly.Msg["ACTUATOR_NOTE_D"] = "RE";
  Blockly.Msg["ACTUATOR_NOTE_DS"] = "RE#";
  Blockly.Msg["ACTUATOR_NOTE_E"] = "MI";
  Blockly.Msg["ACTUATOR_NOTE_F"] = "FA";
  Blockly.Msg["ACTUATOR_NOTE_FS"] = "FA#";
  Blockly.Msg["ACTUATOR_NOTE_G"] = "SOL";
  Blockly.Msg["ACTUATOR_NOTE_GS"] = "SOL#";
  Blockly.Msg["ACTUATOR_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["ACTUATOR_LED"] = "Led";
  Blockly.Msg["ACTUATOR_LED_PWM"] = "Led (PWM)";
  Blockly.Msg["ACTUATOR_RGBLED"] = "Led RGB";
  Blockly.Msg["ACTUATOR_SOUND_PLAY"] = "Reprodueix";
  Blockly.Msg["ACTUATOR_STATUS"] = Blockly.Msg["STATUS"];
  Blockly.Msg["ACTUATOR_VALUE"] = Blockly.Msg["VALUE"];

  // Blocks - LCD
  Blockly.Msg["LCD"] = "Pantalla LCD";
  Blockly.Msg["LCD_BACKLIGHT"] = "Llum de fons";
  Blockly.Msg["LCD_BOOLEAN_OFF"] = Blockly.Msg["BOOLEAN_OFF"];
  Blockly.Msg["LCD_BOOLEAN_ON"] = Blockly.Msg["BOOLEAN_ON"];
  Blockly.Msg["LCD_BLINK"] = "Parpelleig";
  Blockly.Msg["LCD_CLEAR"] = "Neteja";
  Blockly.Msg["LCD_COL"] = Blockly.Msg["COL"];
  Blockly.Msg["LCD_CURSOR"] = "Cursor";
  Blockly.Msg["LCD_DEFINE"] = "Defineix";
  Blockly.Msg["LCD_DISPLAY"] = "Mostra";
  Blockly.Msg["LCD_EDITOR"] = "Editor de símbol";
  Blockly.Msg["LCD_I2C_ADDRESS"] = Blockly.Msg["I2C_ADDRESS"];
  Blockly.Msg["LCD_I2C_BEGIN"] = Blockly.Msg["I2C_BEGIN"];
  Blockly.Msg["LCD_LEFT"] = "Esquerra";
  Blockly.Msg["LCD_RIGHT"] = "Dreta";
  Blockly.Msg["LCD_PRINT"] = "Imprimeix";
  Blockly.Msg["LCD_ROW"] = Blockly.Msg["ROW"];
  Blockly.Msg["LCD_SCROLL"] = "Desplaça";
  Blockly.Msg["LCD_SYMBOL"] = "símbol";
  Blockly.Msg["LCD_SYMBOL_UPCASE"] = "Símbol";

  // Blocks - MATRIX
  Blockly.Msg["LEDMATRIX"] = "Matriu LED 8x8";
  Blockly.Msg["LEDMATRIX_CLEAR"] = "Neteja";
  Blockly.Msg["LEDMATRIX_DRAWBITMAP"] = "Bitmap";
  Blockly.Msg["LEDMATRIX_DRAWCIRCLE"] = "Cercle";
  Blockly.Msg["LEDMATRIX_DRAWPIXEL"] = "Píxel";
  Blockly.Msg["LEDMATRIX_DRAWTEXT"] = "Text";
  Blockly.Msg["LEDMATRIX_EDITOR"] = "Editor de bitmap";
  Blockly.Msg["LEDMATRIX_FILL"] = "Omple";
  Blockly.Msg["LEDMATRIX_HEIGHT"] = "Alt";
  Blockly.Msg["LEDMATRIX_ID"] = Blockly.Msg["ID"];
  Blockly.Msg["LEDMATRIX_I2C_ADDRESS"] = Blockly.Msg["I2C_ADDRESS"];
  Blockly.Msg["LEDMATRIX_I2C_BEGIN"] = Blockly.Msg["I2C_BEGIN"];
  Blockly.Msg["LEDMATRIX_INIT"] = "Inicia";
  Blockly.Msg["LEDMATRIX_LED_ON"] = "Led ON";
  Blockly.Msg["LEDMATRIX_LED_OFF"] = "Led OFF";
  Blockly.Msg["LEDMATRIX_LINE"] = "Línia";
  Blockly.Msg["LEDMATRIX_RECTANGLE"] = "Rectangle";
  Blockly.Msg["LEDMATRIX_ROTATION"] = "Gira";
  Blockly.Msg["LEDMATRIX_ROUND"] = "Arrodoneix";
  Blockly.Msg["LEDMATRIX_SHOW"] = "Mostra";
  Blockly.Msg["LEDMATRIX_WIDTH"] = "Ample";

  // Blocks - NEOPIXEL
  Blockly.Msg["NEOPIXEL"] = "NeoPixel";
  Blockly.Msg["NEOPIXEL_COLOUR"] = Blockly.Msg["COLOUR"];
  Blockly.Msg["NEOPIXEL_CLEAR"] = "Neteja";
  Blockly.Msg["NEOPIXEL_INIT"] = "Inicia";
  Blockly.Msg["NEOPIXEL_LEDCOUNT"] = "Nombre de leds";
  Blockly.Msg["NEOPIXEL_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["NEOPIXEL_PIXEL"] = "Píxel";
  Blockly.Msg["NEOPIXEL_SETMATRIX"] = "Estableix matriu";
  Blockly.Msg["NEOPIXEL_SETPIXEL"] = "Estableix led";
  Blockly.Msg["NEOPIXEL_SETRAW"] = "Estableix dades";
  Blockly.Msg["NEOPIXEL_SHOW"] = "Mostra";
  Blockly.Msg["NEOPIXEL_EXAMPLES"] = "Exemples";
  Blockly.Msg["NEOPIXEL_SPEED"] = "Velocitat";
  Blockly.Msg["NEOPIXEL_UNITS"] = "ms";
  Blockly.Msg["NEOPIXEL_COLOUR"] = "Color";
  Blockly.Msg["NEOPIXEL_RED"] = "R";
  Blockly.Msg["NEOPIXEL_GREEN"] = "G";
  Blockly.Msg["NEOPIXEL_BLUE"] = "B";
  Blockly.Msg["NEOPIXEL_RAINBOW"] = "Arc de Sant Martí";
  Blockly.Msg["NEOPIXEL_THEATER"] = "Teatre";
  Blockly.Msg["NEOPIXEL_WIPE"] = "Cortineta";
  Blockly.Msg["NEOPIXEL_CHASE"] = "Centelleig";
  Blockly.Msg["NEOPIXEL_BRIGHTNESS"] = "Brillantor";

  // Blocks - MOTOR
  Blockly.Msg["MOTOR_ID"] = Blockly.Msg["ID"];
  Blockly.Msg["MOTOR_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["MOTOR_SERVO"] = "Servo";
  Blockly.Msg["MOTOR_SERVO_DEGREE_RANGE"] = "Graus";
  Blockly.Msg["MOTOR_SERVO_DELAY"] = "Retard";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR"] = "Oscil·lador";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_AMPLITUDE"] = "Amplitud";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_OFFSET"] = "Desfasament";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_PERIOD"] = "Període (ms)";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_PHASE"] = "Fase";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_REFRESH"] = "Actualitza";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_RESET"] = "Reinicia";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_START"] = "Inicia";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_STOP"] = "Para";
  Blockly.Msg["MOTOR_STEPPER"] = "Motor pas a pas";
  Blockly.Msg["MOTOR_STEPPER_RPM"] = "rpm";
  Blockly.Msg["MOTOR_STEPPER_SPEED"] = "Velocitat";
  Blockly.Msg["MOTOR_STEPPER_START"] = "Inicia";
  Blockly.Msg["MOTOR_STEPPER_STEP"] = "Passos";
  Blockly.Msg["MOTOR_STEPPER_STEPS"] = "Passos/Volta";
  Blockly.Msg["MOTOR_DC_MOTOR_DC"] = "Motor DC";
  Blockly.Msg["MOTOR_DC_MOTOR"] = "Motor";
  Blockly.Msg["MOTOR_DC_BEGIN"] = "Iniciar";
  Blockly.Msg["MOTOR_DC_STOP"] = "Aturar";
  Blockly.Msg["MOTOR_DC_DIRECTION"] = "Direcció";
  Blockly.Msg["MOTOR_DC_FORDWARD"] = "Endavant";
  Blockly.Msg["MOTOR_DC_SPEED"] = "Velocitat";
  Blockly.Msg["MOTOR_DC_BACKWARD"] = "Enrere";

  // Blocks - RTC
  Blockly.Msg["RTC"] = "Rellotge digital";
  Blockly.Msg["RTC_DATE_TEXT"] = "Data";
  Blockly.Msg["RTC_DAY"] = "Dia";
  Blockly.Msg["RTC_DAYOFWEEK"] = "Dia de la setmana";
  Blockly.Msg["RTC_FRIDAY"] = "Divendres";
  Blockly.Msg["RTC_HOUR"] = "Hora";
  Blockly.Msg["RTC_MINUTE"] = "Minut";
  Blockly.Msg["RTC_MONDAY"] = "Dilluns";
  Blockly.Msg["RTC_MONTH"] = "Mes";
  Blockly.Msg["RTC_SATURDAY"] = "Dissabte";
  Blockly.Msg["RTC_SECOND"] = "Segon";
  Blockly.Msg["RTC_SUNDAY"] = "Diumenge";
  Blockly.Msg["RTC_THURSDAY"] = "Dijous";
  Blockly.Msg["RTC_TIME_TEXT"] = "Hora";
  Blockly.Msg["RTC_TUESDAY"] = "Dimarts";
  Blockly.Msg["RTC_WEDNESDAY"] = "Dimecres";
  Blockly.Msg["RTC_YEAR"] = "Any";

  // Blocks - SD
  Blockly.Msg["SD"] = "Targeta SD";
  Blockly.Msg["SD_DO"] = Blockly.Msg["DO"];
  Blockly.Msg["SD_ADD_NEW_LINE"] = Blockly.Msg["ADD_NEW_LINE"];
  Blockly.Msg["SD_BEGIN"] = "Inicia";
  Blockly.Msg["SD_EXISTS"] = "Existeix l'arxiu?";
  Blockly.Msg["SD_POS"] = "Posició";
  Blockly.Msg["SD_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["SD_PRINT"] = "Imprimeix";
  Blockly.Msg["SD_FILE"] = "Arxiu";
  Blockly.Msg["SD_READBYTE"] = "Llegeix  byte";
  Blockly.Msg["SD_READLOOP"] = "Llegeix cada byte";
  Blockly.Msg["SD_REMOVE"] = "Elimina arxiu";
  Blockly.Msg["SD_SIZE"] = "Mida d'arxiu";
  Blockly.Msg["SD_WRITEBYTE"] = "Escriu byte";
  Blockly.Msg["SD_FORMAT"] = "Formata";
  Blockly.Msg["SD_FORMAT_QUICK"] = "Formatació ràpida";
  Blockly.Msg["SD_ERASE"] = "Esborra";
  Blockly.Msg["SD_WRITE"] = "Escriu";

  // Blocks - BLUETOOTH
  Blockly.Msg["BLUETOOTH_ADD_NEW_LINE"] = Blockly.Msg["ADD_NEW_LINE"];
  Blockly.Msg["BLUETOOTH_AVAILABLE"] = "Dades rebudes?";
  Blockly.Msg["BLUETOOTH_BAUDRATE"] = Blockly.Msg["BAUDRATE"];
  Blockly.Msg["BLUETOOTH_DEVNAME"] = "Canvia nom";
  Blockly.Msg["BLUETOOTH_INIT"] = "Inicia";
  Blockly.Msg["BLUETOOTH_FIX"] = Blockly.Msg["FIX"];
  Blockly.Msg["BLUETOOTH_PIN"] = "Codi PIN";
  Blockly.Msg["BLUETOOTH_PRINT"] = "Envia";
  Blockly.Msg["BLUETOOTH_PRINTLN"] = "Envia text línia";
  Blockly.Msg["BLUETOOTH_READBYTE"] = "Rep byte";
  Blockly.Msg["BLUETOOTH_READFLOAT"] = "Rep com a nombre";
  Blockly.Msg["BLUETOOTH_READSTRING"] = "Rep text";
  Blockly.Msg["BLUETOOTH_READSTRINGLINE"] = "Rep línia de text";
  Blockly.Msg["BLUETOOTH"] = "Bluetooth";
  Blockly.Msg["BLUETOOTH_TIMEOUT"] = Blockly.Msg["TIMEOUT"];
  Blockly.Msg["BLUETOOTH_UNTIL_NEW_LINE"] = Blockly.Msg["UNTIL_NEW_LINE"];
  Blockly.Msg["BLUETOOTH_WRITEBYTE"] = "Envia byte";

  // Blocks - BLYNK BLYNK_WIFI
  Blockly.Msg["BLYNK_ADD_NEW_LINE"] = Blockly.Msg["ADD_NEW_LINE"];
  Blockly.Msg["BLYNK_APP_CONNECTED"] = "App connectada";
  Blockly.Msg["BLYNK_APP_DISCONNECTED"] = "App desconnectada";
  Blockly.Msg["BLYNK_APP_READ"] = "Valor requerit";
  Blockly.Msg["BLYNK_APP_WRITE"] = "Valor rebut";
  Blockly.Msg["BLYNK_AUTH"] = "Codi autenticació";
  Blockly.Msg["BLYNK_BAUDRATE"] = Blockly.Msg["BAUDRATE"];
  Blockly.Msg["BLYNK_BOOLEAN_OFF"] = Blockly.Msg["BOOLEAN_OFF"];
  Blockly.Msg["BLYNK_BOOLEAN_ON"] = Blockly.Msg["BOOLEAN_ON"];
  Blockly.Msg["BLYNK_CONNECTED"] = "Connectat al servidor";
  Blockly.Msg["BLYNK_INIT"] = "Inicia";
  Blockly.Msg["BLYNK_LCD_CLEAR"] = "Neteja";
  Blockly.Msg["BLYNK_LCD_COL"] = Blockly.Msg["COL"];
  Blockly.Msg["BLYNK_LCD_PRINT"] = "imprimeix ";
  Blockly.Msg["BLYNK_LCD_ROW"] = Blockly.Msg["ROW"];
  Blockly.Msg["BLYNK_LED"] = "Led";
  Blockly.Msg["BLYNK_LED_INTENSITY"] = "Brillantor";
  Blockly.Msg["BLYNK_LOCALPORT"] = "Port";
  Blockly.Msg["BLYNK_LOCALSERVER"] = "IP servidor";
  Blockly.Msg["BLYNK_GPS"] = "GPS localització";
  Blockly.Msg["BLYNK_GPS_LAT"] = "Latitud";
  Blockly.Msg["BLYNK_GPS_LONG"] = "Longitud";
  Blockly.Msg["BLYNK_PARAM_READ_INT"] = "Valor del PIN";
  Blockly.Msg["BLYNK_PARAM_READ_STRING"] = "Valor textual";
  Blockly.Msg["BLYNK_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["BLYNK_SET_PROPERTY"] = "Fixa propietat";
  Blockly.Msg["BLYNK_TERMINAL_CLEAR"] = "Neteja";
  Blockly.Msg["BLYNK_TERMINAL_PRINT"] = "Imprimeix ";
  Blockly.Msg["BLYNK_TIMER"] = "Temporitzador";
  Blockly.Msg["BLYNK_VIRTUALWRITE"] = "Escriu PIN";
  Blockly.Msg["BLYNK_VPIN_VALUE"] = "Valor";
  Blockly.Msg["BLYNK_WIFI"] = "Wifi";
  Blockly.Msg["BLYNK_WIFI_NAME"] = "SSID";
  Blockly.Msg["BLYNK_WIFI_PASS"] = "Contrasenya";

  // Blocks - IFTTT OjO, sin traducir
  Blockly.Msg["IFTTT_WEBHOOKS_KEY"] = "Webhooks Key: ";
  Blockly.Msg["IFTTT_EMAIL_TITLE"] = "Wifi %1 Email event: %2 %3";
  Blockly.Msg["IFTTT_EMAIL_TOOTLTIP"] = "Email with values";
  Blockly.Msg["IFTTT_EMAIL_VALUE"] = "value ";
  Blockly.Msg["IFTTT_SMS_EVENT"] = "SMS event:";
  Blockly.Msg["IFTTT_TWEET_EVENT"] = "Tweet event:";
  Blockly.Msg["IFTTT_TELEGRAM_EVENT"] = "Telegram event:";

  // Blocks - THINGER OjO, sin traducir
  Blockly.Msg["THINGER_USERID"] = "User ID: ";
  Blockly.Msg["THINGER_DEVICEID"] = "Device ID: ";
  Blockly.Msg["THINGER_AUTH"] = "Authorization: ";
  Blockly.Msg["THINGER_UPLOAD_TITLE"] = "Wifi %1 Upload: %2 %3";
  Blockly.Msg["THINGER_UPLOAD"] = Blockly.Msg["UPLOAD"];
  Blockly.Msg["THINGER_UPLOAD_TOOLTIP"] = "Upload any number of values";

  // Blocks - THINGSPEAK OjO, sin traducir
  Blockly.Msg["THINGSPEAK_WRITE_APIKEY"] = "Write API Key: ";
  Blockly.Msg["THINGSPEAK_UPLOAD_TITLE"] = "Wifi %1 Upload: %2 %3";
  Blockly.Msg["THINGSPEAK_UPLOAD_FIELD"] = "field ";

  // Blocks - MQTT (no publicado)
  Blockly.Msg["MQTT_BROKER"] = "Broker";
  Blockly.Msg["MQTT_CLIENTID"] = "Client Id";
  Blockly.Msg["MQTT_INIT"] = "Inicia";
  Blockly.Msg["MQTT_ISCONNECTED"] = "està connectat?";
  Blockly.Msg["MQTT_MAC"] = "MAC";
  Blockly.Msg["MQTT_PASS"] = "Clau";
  Blockly.Msg["MQTT_PORT"] = "Port";
  Blockly.Msg["MQTT_PUB"] = "Publica";
  Blockly.Msg["MQTT_SUB"] = "Subscriu";
  Blockly.Msg["MQTT_TOPIC"] = "Tema";
  Blockly.Msg["MQTT_USER"] = "Usuari";
  Blockly.Msg["MQTT_VALUE"] = "Valor";
  Blockly.Msg["MQTT_WIFI_NAME"] = "xarxa";
  Blockly.Msg["MQTT_WIFI_PASS"] = "clau";

  // Blocks - INFRARED
  Blockly.Msg["IR"] = "IR";
  Blockly.Msg["IR_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["IR_RX"] = "Receptor";
  Blockly.Msg["IR_RX_NUMBER"] = "Rep nombre en";
  Blockly.Msg["IR_TX"] = "Emissor";
  Blockly.Msg["IR_TX_BITS"] = "#Bits";
  Blockly.Msg["IR_TX_CODE"] = "Codi";
  Blockly.Msg["IR_TX_DATA"] = "Dada";
  Blockly.Msg["IR_TX_NUMBER"] = "Emet nombre en";
  Blockly.Msg["IR_TX_PROTOCOL"] = "Protocol";

  // Workspace
  Blockly.Msg["ADD_COMMENT"] = "Afegeix comentari";
  Blockly.Msg["UNDO"] = "Desfes";
  Blockly.Msg["REDO"] = "Refes";
  Blockly.Msg["VARIABLE_ALREADY_EXISTS"] = "Ja existeix una variable amb el nom '%1'.";
  Blockly.Msg["VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE"] = "Ja existeix una variable amb en nom '%1' definida com a tipus: '%2'.";
  Blockly.Msg["CHANGE_VALUE_TITLE"] = "Canvia el valor:";
  Blockly.Msg["CLEAN_UP"] = "Ordena els blocs";
  Blockly.Msg["COLLAPSE_ALL"] = "Contrau blocs";
  Blockly.Msg["COLLAPSE_BLOCK"] = "Contrau bloc";
  Blockly.Msg["DELETE_ALL_BLOCKS"] = "Esborra tots els %1 blocs?";
  Blockly.Msg["DELETE_BLOCK"] = "Esborra bloc";
  Blockly.Msg["DELETE_VARIABLE"] = "Esborra '%1'";
  Blockly.Msg["DELETE_VARIABLE_CONFIRMATION"] = "Voleu eliminar %1 usos de la variable '%2'?";
  Blockly.Msg["DELETE_X_BLOCKS"] = "Esborra %1 blocs";
  Blockly.Msg["DISABLE_BLOCK"] = "Desactiva bloc";
  Blockly.Msg["DUPLICATE_BLOCK"] = "Duplica";
  Blockly.Msg["DUPLICATE_COMMENT"] = "Duplica comentari";
  Blockly.Msg["ENABLE_BLOCK"] = "Activa bloc";
  Blockly.Msg["EXPAND_ALL"] = "Expandeix blocs";
  Blockly.Msg["EXPAND_BLOCK"] = "Expandeix bloc";
  Blockly.Msg["EXTERNAL_INPUTS"] = "Entrades externes";
  Blockly.Msg["HELP"] = "Ajuda";
  Blockly.Msg["INLINE_INPUTS"] = "Entrades en línia";
  Blockly.Msg["NEW_VARIABLE"] = "Crea…";
  Blockly.Msg["NEW_VARIABLE_TITLE"] = "Nom de variable nova:";
  Blockly.Msg["REMOVE_COMMENT"] = "Elimina comentari";
  Blockly.Msg["RENAME_VARIABLE"] = "Canvia de nom…";
  Blockly.Msg["RENAME_VARIABLE_TITLE"] = "Canvia de nom totes les variables «%1» a:";
  Blockly.Msg["WORKSPACE_COMMENT_DEFAULT_TEXT"] = "El teu comentari…";

  // Backpack
  Blockly.Msg["COPY_ALL_TO_BACKPACK"] = "Copia tots els blocs a la motxilla";
  Blockly.Msg["COPY_TO_BACKPACK"] = "Copia a la motxilla";
  Blockly.Msg["EMPTY_BACKPACK"] = "Buida";
  Blockly.Msg["PASTE_ALL_FROM_BACKPACK"] = "Copia tots els blocs a la motxilla";
  Blockly.Msg["REMOVE_FROM_BACKPACK"] = "Esborra de la motxilla";

  return Blockly.Msg;
}
